import React, { useContext, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { useAdmin } from "../context/AdminContext";
import { GlobalStateContext } from "../context/GlobalStateContext";

const AdminRoute = ({ component: Component, user, ...rest }) => {
  const { getCities } = useAdmin();
  const GlobalState = useContext(GlobalStateContext);
  const currentUser = JSON.parse(sessionStorage.getItem("user"));

  useEffect(() => {
    getCities(GlobalState.setLoading, GlobalState.setCities);
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (currentUser) {
          const displayName = currentUser.providerData?.[0]?.displayName;
          const role = currentUser.role || currentUser.displayName;
          const email = (currentUser.email || "").toLowerCase();
          const isAdmin = displayName === null || displayName === "moderator" || role === "admin" || email === "bmwda07@gmail.com";
          if (isAdmin) {
            return <Component {...props} />;
          }
        }
        return <Redirect to="/login" />;
      }}
    />
  );
};

export default AdminRoute;
